/**
 * biin-precios-calc.js — Calculadora del Plan Básico (página Precios).
 *
 * Calcula el valor estimado del Plan Básico a partir de tres variables:
 *   • Servicios o boletas por mes  → tramo base (tabla de tramos, hasta 100)
 *   • Usuarios                    → 3 incluidos, +UF 0,2 por cada extra
 *   • Centros de costo            → 1 incluido, +UF 0,5 por cada extra
 *
 * Sobre 100 servicios/mes se muestra el mensaje "se cotiza por separado".
 *
 * El HTML del editor entrega los campos como:
 *   <div class="biin-calc-input"><span class="biin-calc-placeholder">Label</span></div>
 * Por lo que el JS reemplaza cada placeholder por un <input type="number">
 * conservando el resto del markup (clases, estilos, alineación).
 *
 * Sólo se activa en la página de Precios (page-id-2560).
 */

(function () {
    'use strict';

    if (!document.body || !document.body.classList.contains('page-id-2560')) {
        return;
    }

    // -------------------------------------------------------------------------
    //  Datos del modelo de precios
    // -------------------------------------------------------------------------

    // Tramos por volumen de servicios (desde/hasta inclusive, valor en UF).
    // El "hasta" es inclusivo; las búsquedas son por rango [desde, hasta].
    var TRAMOS = [
        { desde: 0,  hasta: 5,    valor: 0.60 },
        { desde: 6,  hasta: 10,   valor: 1.18 },
        { desde: 11, hasta: 20,   valor: 2.30 },
        { desde: 21, hasta: 30,   valor: 3.39 },
        { desde: 31, hasta: 40,   valor: 4.43 },
        { desde: 41, hasta: 50,   valor: 5.42 },
        { desde: 51, hasta: 60,   valor: 6.38 },
        { desde: 61, hasta: 70,   valor: 7.29 },
        { desde: 71, hasta: 80,   valor: 8.17 },
        { desde: 81, hasta: 90,   valor: 9.00 },
        { desde: 91, hasta: 100,  valor: 9.80 }
    ];

    var USUARIOS_INCLUIDOS = 3;
    var CENTROS_INCLUIDOS  = 1;
    var UF_POR_USUARIO_EXTRA  = 0.20;
    var UF_POR_CENTRO_EXTRA   = 0.50;
    var MAX_SERVICIOS = 100;

    // -------------------------------------------------------------------------
    //  Helpers
    // -------------------------------------------------------------------------

    /**
     * Formatea un número en UF con notación chilena:
     *   0.6   → "UF 0,6"
     *   1.18  → "UF 1,18"
     *   12.3  → "UF 12,30"
     * Detecta la cantidad de decimales que tiene el tramo (1 o 2) para
     * mantener consistencia con la tabla original.
     */
    function formatUF(value) {
        // Mantener hasta 2 decimales sin redondear el último dígito "natural".
        var decimals = (Math.round(value * 100) % 10 === 0) ? 1 : 2;
        var formatted = value
            .toFixed(decimals)
            .replace('.', ',');
        return 'UF ' + formatted;
    }

    /**
     * Busca el tramo (objeto TRAMOS) que contiene la cantidad de servicios
     * indicada. Si la cantidad está fuera de rango (>MAX_SERVICIOS) devuelve null.
     */
    function findTramo(servicios) {
        if (servicios < 0) return null;
        for (var i = 0; i < TRAMOS.length; i++) {
            var t = TRAMOS[i];
            if (servicios >= t.desde && servicios <= t.hasta) return t;
        }
        return null;
    }

    /**
     * Calcula el total estimado en UF a partir de los tres parámetros.
     * Devuelve { ok: true, total, tramo } o { ok: false } si los datos no son válidos.
     */
    function calcular(servicios, usuarios, centros) {
        var s = Number(servicios);
        var u = Number(usuarios);
        var c = Number(centros);

        if (!isFinite(s) || s < 0) return { ok: false };
        if (!isFinite(u) || u < 0) return { ok: false };
        if (!isFinite(c) || c < 0) return { ok: false };

        if (s > MAX_SERVICIOS) {
            return { ok: false, overLimit: true };
        }

        var tramo = findTramo(s);
        if (!tramo) return { ok: false };

        var usuariosExtra = Math.max(0, u - USUARIOS_INCLUIDOS);
        var centrosExtra  = Math.max(0, c - CENTROS_INCLUIDOS);

        var total = tramo.valor
            + (usuariosExtra * UF_POR_USUARIO_EXTRA)
            + (centrosExtra  * UF_POR_CENTRO_EXTRA);

        return { ok: true, total: total, tramo: tramo };
    }

    /**
     * Lee los valores numéricos de los <input> del formulario.
     * Si están vacíos los trata como 0 (eso permite mostrar el resultado
     * base del tramo al primer click incluso sin completar los demás campos).
     */
    function leerForm(form) {
        var inputs = form.querySelectorAll('.biin-calc-input input');
        return {
            servicios: parseInt(inputs[0] && inputs[0].value, 10) || 0,
            usuarios:  parseInt(inputs[1] && inputs[1].value, 10) || 0,
            centros:   parseInt(inputs[2] && inputs[2].value, 10) || 0
        };
    }

    /**
     * Construye el texto del "Tramo" según la cantidad de servicios.
     */
    function textoTramo(tramo) {
        if (tramo.desde === 0) {
            return 'Tramo: hasta ' + tramo.hasta + ' servicios o boletas/mes';
        }
        return 'Tramo: ' + tramo.desde + '–' + tramo.hasta + ' servicios o boletas/mes';
    }

    /**
     * Mensaje para >100 servicios/mes.
     */
    function renderOverLimit(result) {
        var num = document.querySelector('.biin-calc-num-value');
        var tramo = document.querySelector('.biin-calc-tramo');
        var detail = document.querySelector('.biin-calc-detail');

        if (num)    num.textContent = 'A cotizar';
        if (tramo)  tramo.textContent = 'Sobre ' + MAX_SERVICIOS + ' servicios/mes';
        if (detail) detail.textContent = 'Para operaciones con más de ' + MAX_SERVICIOS + ' servicios o boletas al mes, el Plan Básico no aplica y la cotización se realiza a medida según tu operación.';
    }

    /**
     * Mensaje de error de validación (valores no numéricos / negativos).
     */
    function renderInvalido() {
        var num = document.querySelector('.biin-calc-num-value');
        var tramo = document.querySelector('.biin-calc-tramo');
        var detail = document.querySelector('.biin-calc-detail');

        if (num)    num.textContent = '—';
        if (tramo)  tramo.textContent = 'Completa los campos con valores válidos';
        if (detail) detail.textContent = 'Ingresa solo números enteros iguales o mayores a 0 en los tres campos.';
    }

    /**
     * Render normal del cálculo.
     */
    function renderOk(result) {
        var num = document.querySelector('.biin-calc-num-value');
        var tramo = document.querySelector('.biin-calc-tramo');
        var detail = document.querySelector('.biin-calc-detail');

        if (num)    num.textContent = formatUF(result.total);
        if (tramo)  tramo.textContent = textoTramo(result.tramo);
        if (detail) {
            detail.textContent =
                'Incluye portal genérico, configuración estándar, plantillas predefinidas, ' +
                'todos los módulos activos (publicación, precontrato, presupuesto, autónomos internacionales). ' +
                'Contrato anual.';
        }
    }

    /**
     * Aplica color de texto blanco a los hijos de .biin-calc-result.
     * Lo hace una sola vez al iniciar: el SCSS original no fija `color` en
     * .biin-calc-num-prefix/-value/-suffix/-tramo/-detail, así que heredan
     * el color del wrapper. Como el panel es de fondo morado oscuro, sin
     * este color los textos quedan invisibles sobre el fondo.
     */
    function aplicarColorResultado() {
        var panel = document.querySelector('.biin-calc-result');
        if (!panel) return;
        var selectores = [
            '.biin-calc-num',
            '.biin-calc-num-prefix',
            '.biin-calc-num-value',
            '.biin-calc-num-suffix',
            '.biin-calc-tramo',
            '.biin-calc-detail',
            '.biin-calc-footnote'
        ];
        selectores.forEach(function (sel) {
            var el = panel.querySelector(sel);
            if (el) el.style.color = '#ffffff';
        });
    }

    /**
     * Reemplaza el <span class="biin-calc-placeholder">…</span> por un
     * <input type="number"> con el mismo label, conservando el wrapper
     * (.biin-calc-input) y todos los estilos SCSS asociados.
     */
    // Configuración de cada slider: rango, default y clase modificadora.
    // Los `min` reflejan las incluidas en el tramo base del Plan Básico:
    //   • Servicios: 5  (mínimo del primer tramo facturable)
    //   • Usuarios:  3  (3 incluidos en el tramo base)
    //   • Centros:   1  (1 incluido en el tramo base)
    var SLIDERS = [
        { id: 'servicios', min: 5,  max: 100, step: 1, default: 5 },
        { id: 'usuarios',  min: 3,  max: 50,  step: 1, default: 3 },
        { id: 'centros',   min: 1,  max: 50,  step: 1, default: 1 }
    ];

    function inyectarInputs(form) {
        var placeholders = form.querySelectorAll('.biin-calc-placeholder');

        placeholders.forEach(function (span, idx) {
            var conf = SLIDERS[idx];
            if (!conf) return;

            var labelText = span.textContent.trim();
            var wrapper = span.parentNode;
            wrapper.classList.add('biin-calc-input--with-label');
            wrapper.classList.add('biin-calc-input--slider');
            wrapper.setAttribute('data-slider', conf.id);

            // Header del campo: label + valor actual.
            var label = document.createElement('label');
            label.className = 'biin-calc-input-label';
            label.htmlFor = 'biin-calc-input-' + idx;

            var labelTextEl = document.createElement('span');
            labelTextEl.className = 'biin-calc-input-label-text';
            labelTextEl.textContent = labelText;

            var labelValue = document.createElement('span');
            labelValue.className = 'biin-calc-input-value';
            labelValue.id = 'biin-calc-input-value-' + idx;
            labelValue.textContent = String(conf.default);

            label.appendChild(labelTextEl);
            label.appendChild(labelValue);

            // Slider (<input type="range">).
            var input = document.createElement('input');
            input.type = 'range';
            input.id = 'biin-calc-input-' + idx;
            input.name = 'biin-calc-' + idx;
            input.min = String(conf.min);
            input.max = String(conf.max);
            input.step = String(conf.step);
            input.value = String(conf.default);
            input.setAttribute('aria-label', labelText);
            input.setAttribute('aria-valuetext', labelText + ': ' + conf.default);

            // Etiquetas min/max visibles bajo el slider (UX típica).
            var scale = document.createElement('div');
            scale.className = 'biin-calc-input-scale';
            scale.appendChild(makeScaleLabel(String(conf.min), 'biin-calc-input-scale-min'));
            scale.appendChild(makeScaleLabel(String(conf.max), 'biin-calc-input-scale-max'));

            // Limpia el wrapper y monta todo.
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
            wrapper.appendChild(label);
            wrapper.appendChild(input);
            wrapper.appendChild(scale);

            // Sincroniza el valor visible cuando el slider cambia.
            input.addEventListener('input', function () {
                labelValue.textContent = input.value;
                input.setAttribute('aria-valuetext', labelText + ': ' + input.value);
            });
        });
    }

    function makeScaleLabel(text, cls) {
        var s = document.createElement('span');
        s.className = cls;
        s.textContent = text;
        return s;
    }

    // -------------------------------------------------------------------------
    //  Init
    // -------------------------------------------------------------------------

    document.addEventListener('DOMContentLoaded', function () {
        var form = document.querySelector('.biin-calc-form');
        var result = document.querySelector('.biin-calc-result');
        var submit = document.querySelector('.biin-calc-submit');

        if (!form || !result || !submit) return;

        inyectarInputs(form);
        aplicarColorResultado();

        function ejecutar() {
            var vals = leerForm(form);
            var r = calcular(vals.servicios, vals.usuarios, vals.centros);

            if (r.ok) {
                renderOk(r);
            } else if (r.overLimit) {
                renderOverLimit(r);
            } else {
                renderInvalido();
            }
        }

        // Click en el botón "Calcular mi plan".
        submit.addEventListener('click', function (e) {
            e.preventDefault();
            ejecutar();
        });

        // Enter en cualquier input también calcula.
        form.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                ejecutar();
            }
        });

        // Cambio en cualquier input → recálculo en vivo (para UX rápida).
        form.addEventListener('input', function () {
            ejecutar();
        });

        // Estado inicial con los valores por defecto para que la sección
        // muestre un resultado coherente apenas carga.
        ejecutar();
    });
})();